import React from 'react';
import { MoneyView, MoneyV2, Money } from '../../MoneyView';

interface Props {
  amount: Money;
  percentFee?: number | null;
  fixedFee?: MoneyV2;
  isReverse?: boolean;
}

function getAmount({ amount, percentFee, fixedFee, isReverse }: Props): Money {
  if (fixedFee) {
    return {
      value: Math.max(amount.value - +(fixedFee.value || 0), 0),
      currency: amount.currency,
    };
  }

  if (percentFee) {
    if (isReverse) {
      return {
        value: amount.value - (amount.value * percentFee) / 100,
        currency: amount.currency,
      };
    }

    return {
      value: amount.value * (1 + percentFee / 100),
      currency: amount.currency,
    };
  }

  return {
    value: 0,
    currency: amount.currency,
  };
}

export const Net: React.FC<Props> = (props) => <MoneyView rule="0-2">{getAmount(props)}</MoneyView>;
